// # #############################################
// # Title : Radio Button
// # Authors : Sameer, Dhruv, Shubham, Mahesh
// # Date : 15th October 2019
// # Last Modified : Dhruv, August 2019
// # Version : 19.10.03
// # Description : This is the code for rendering the trmperature charts on the scenario dynamics tab
// # ############################################

import React, { Component } from "react";
import Highcharts from "highcharts";
import '../css/tempData.css'
// var quantile = require('compute-quantile');
var moment = require('moment');





class TempGraph extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // data: [-7.31, -6.85, -6.09, -5.2, -4.11, -2.84, -1.78, -0.92, -0.73, -0.79, -1.62, -2.11, -3.01, -3.63, -4.12, -4.68, -5.26, -5.69, -5.84, -6.18, -6.36, -6.66, -6.72, -6.79, -7.09, -6.86, -5.89, -4.88, -3.57, -2.4, -1.15, -0.28, 0.32, 0.59, 0.22, -0.01, -0.67, -1.55, -2.02, -2.53, -3.33, -3.47, -3.5, -3.77, -3.85, -4.27, -4.56],
      data: [],
      displayChart: false,
      // quant1: 0,
      // quant2: 0,
      // max: 0,
    }
  }

  // findingQuantiles = (inputData) => {
  //   const data = inputData;
  //   let low = quantile(data, 0.5, { "sorted": false });
  //   let med = quantile(data, 0.75, { "sorted": false });
  //   let max = Math.max(...data)

  //   this.setState({
  //     quant1: low,
  //     quant2: med,
  //     max: max
  //   });
  // }


  componentDidMount() {

    if (!Array.prototype.hasOwnProperty("chunk")) {
      // eslint-disable-next-line
      Object.defineProperty(Array.prototype, 'chunk', {
        value: function (chunkSize) {
          var R = [];
          for (var i = 0; i < this.length; i += chunkSize)
            R.push(this.slice(i, i + chunkSize));
          return R;
        }
      });
    }

    this.props.subscribe_ns("HUD_data", data => {
      let result = data.temperature.slice(1).chunk(24).map(array => Math.max(...array))
      let temp = [];
      result.forEach((d, i) => {
        temp.push([i + 1, d])
      });

      this.setState({
        data: temp,
      });
      // this.findingQuantiles(result)
    });

    this.addEvents();
  }

  componentDidUpdate() {
    this.loadRevenue(this.state.data)
  }



  loadRevenue(data) {

    function syncExtremes(e) {
      var thisChart = this.chart;

      if (e.trigger !== 'syncExtremes') { // Prevent feedback loop
        Highcharts.each(Highcharts.charts, function (chart) {
          if (chart !== thisChart) {
            if (chart.xAxis[0].setExtremes) { // It is null while updating
              chart.xAxis[0].setExtremes(
                e.min,
                e.max,
                undefined,
                false, {
                trigger: 'syncExtremes'
              }
              );
            }
          }
        });
      }
    }

    Highcharts.chart('container', {
      chart: {
        // height: 150,
        marginLeft: 50, // Keep all charts left aligned
        spacingRight: 40,
        spacingTop: 20,
        spacingBottom: 20,
        shadow: true,
        borderRadius: '5px',
      },
      title: {
        text: 'Temperature ( °C )',
        align: 'left',
        margin: 10,
        x: 30,
        floating: false,
        style: { "fontSize": "14px" }
      },
      subtitle: {
        text: 'Max temp. recorded on that day',
        align: 'left',
        x: 32,
        y: 25,
        style: { "fontSize": "10px" }

      },
      credits: {
        enabled: false
      },
      yAxis: {
        title: {
          text: null
        },
        gridLineColor: 'transparent',
        tickWidth: 1,
        offset: -5,
      },
      tooltip: {
        shared: true,
        crosshairs: true,
        valueDecimals: 2,
        borderColor: "#7DAD24",
        valueSuffix: `°C`,
        positioner: function (boxWidth, boxHeight, point) {

          // Declaring variables to be used 
          let chart = this.chart,
            plotLeft = chart.plotLeft,
            plotWidth = chart.plotWidth,
            pointY = point.plotY,
            x = point.plotX + 50,
            y = point.plotY + 40,
            // eslint-disable-next-line
            alignedRight

          // Writing logic for calculating tooltip position based on the point on the line graph
          if ((x + boxWidth) > (plotLeft + plotWidth)) {
            x -= (x + boxWidth) - (plotLeft + plotWidth);
            y = pointY + 65;
            alignedRight = true;
          }
          return {
            x: x,
            y: y
          };
        },
        //For tooltip header showing Weeks and Days
        formatter: function (tooltip) {
          let header, utcSeconds, d, currDate, day, start;

          if (sessionStorage.getItem("scenarioDetail")) {
            start = new Date(JSON.parse(sessionStorage.getItem("scenarioDetail"))[0].startTime * 1000).setFullYear(2020) / 1000
          }
          else {
            start = new Date(JSON.parse(sessionStorage.getItem("simSettings")).accordians[0].content[2].selectedValue).setFullYear(2020) / 1000
          }
          day = this.x + 1
          utcSeconds = start + (86400) * (day - 1);
          d = new Date(0); // The 0 there is the key, which sets the date to the epoch
          d.setUTCSeconds(utcSeconds);
          currDate = new Date(d);

          header = `<span style="color: blue;"> Day ${day - 1} - ${moment(currDate).format('l')} </span><br/>`
          // header = header = `<span style="color: blue;"> Day ${this.x + 1}</span><br/>`
          return header + (tooltip.bodyFormatter(this.points).join(''))
        }
      },
      xAxis: {
        visible: true,
        allowDecimals: false,
        events: {
          setExtremes: syncExtremes
        },
        // tickPositioner: function() {
        //   this.tickPositions.push(this.getExtremes().dataMax);
        // },
      },
      legend: {
        enabled: false,
        layout: 'horizontal',
        align: 'right',
        verticalAlign: 'top',

      },
      plotOptions: {
        lineWidth: 1,
        series: {
          marker: {
            radius: 1
          }
        }
      },
      series: [{
        animation: false,
        name: 'Temperature',
        type: 'spline',
        data: data,
        zones: [{
          value: 12.7778,
          color: '#5FF7F4'
        }, {
          value: 18.3333,
          color: '#FFDF3A'
        }, {

          color: '#FFFFFF'
        }]
      }],

      // plotOptions: {
      //     series: {
      //         marker: {
      //             fillColor: []
      //         }
      //     }
      // },

      responsive: {
        rules: [{
          condition: {
            maxWidth: 500
          },
          chartOptions: {
            legend: {
              layout: 'horizontal',
              align: 'center',
              verticalAlign: 'bottom'
            }
          }
        }]
      }

    }
    );

  }

  addEvents() {
    ['mousemove', 'touchmove', 'touchstart', 'mouseout'].forEach(function (eventType) {
      document.getElementById('container').addEventListener(
        eventType,
        function (e) {
          for (let i = 0; i < Highcharts.charts.length; ++i) {
            let chart = Highcharts.charts[i];
            if (chart && (chart.renderTo.classList[0] === "v_chart" || chart.renderTo.classList[0] === "chart" || chart.renderTo.id === "container")) {

              let event = chart.pointer.normalize(e); // Find coordinates within the chart
              let point;
              for (let j = 0; j < chart.series.length && !point; ++j) {
                point = chart.series[j].searchPoint(event, true);
              }
              if (!point) {
              }
              else {
                if (e.type === "mousemove") {
                  point.onMouseOver();
                  chart.xAxis[0].drawCrosshair(event, point);
                } else if (e.type === "mouseout") {
                  point.onMouseOut();
                  chart.tooltip.hide(point);
                  chart.xAxis[0].hideCrosshair();
                }
              }
            }
          }
        }
      );
    });
  }



  render() {

    
    return (

        <React.Fragment>
        <div className="InputTrends firstTitle" >
          <span className="leftInput">Environment</span>
          <span className="rightInput">At day level</span>
        </div>
        <div style={{ position: 'relative' }}>
          <div style={{ paddingTop: "10px", padding: "0.5vw", height: "15vh" }} id="container" />
          <div id={'tempLegend'}>
            <div class={'legenedElem'}>
              {/* <div class="square Cold"></div>  */}
              .</div>
            <div class={'legenedElem'}>
              {/* <div class="square Medium">
                  </div>  */}
              .</div>
            <div class={'legenedElem'}>
              {/* <div class="square Hot">
                      </div>  */}
              .</div>
          </div>
          <div id={'tempLegendText'}>
            <div class={'legenedElem'}>
              {/* <div class="square Cold"></div>  */}
              12°C</div>
            <div class={'legenedElem'}>
              {/* <div class="square Medium">
                  </div>  */}
              18°C</div>
            <div class={'legenedElem'}>
              {/* <div class="square Hot">
                      </div>  */}
              20°C</div>
          </div>
        </div>
      </React.Fragment>
      
    );
  }
}

export default TempGraph;